const api = new GhostContentAPI({
    url: "https://1inch-network.ghost.io",
    key: "87ca31649158b9cc803dd86314",
    version: "v5.0",
});


const fetchDataFromGhost = async (resource, options) => {
    try {
        const data = await api[resource].browse(options);
        return data;
    } catch (err) {
        console.error(err);
        return null;
    }
};

const getPosts = async () => {
    const options = {
        limit: "all",
        fields: "title, plaintext, url",
    };
    return fetchDataFromGhost("posts", options);
};

const getTags = async () => {
    const options = {
        limit: "all",
        fields: "name, url",
        filter: 'visibility:public'
    };
    return fetchDataFromGhost("tags", options);
};
